import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'

import React from 'react'

export const ModalValidarCaricatura = ({ caricatura, onApprove, isLoadingApprove }) => {
  const { isOpen: isOpenModal, onOpen, onClose: onCloseModal } = useDisclosure()

  async function handleApprove() {
    await onApprove()

    onCloseModal()
  }

  return (
    <>
      <Button border="1px solid #378BBF" color="#378BBF" onClick={onOpen}>
        Validar
      </Button>
      <Modal isOpen={isOpenModal} onClose={onCloseModal} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Você está validando a caricatura de <strong>{caricatura.nome}</strong>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>Tem certeza que deseja validar essa caricatura?</ModalBody>

          <ModalFooter display="flex" gap={4} justifyContent="flex-end" flexDirection="row" alignItems="center">
            <Button isLoading={isLoadingApprove} onClick={handleApprove} colorScheme="green">
              Sim
            </Button>
            <Button onClick={onCloseModal} colorScheme="red">
              Não
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
